<template>
  <div
    class="container lms-wrapper no-right-sidebar pd-x-0 pd-lg-x-10 pd-xl-x-0"
  >
    <div class="lms-sidebar">
      <div class="lms-sidebar-body">
        <vue-custom-scrollbar :style="`height: ${scrollHeight.nav}px`">
          <div :class="`card ${$store.state.app.isMobile ? 'bd-0' : ''}`">
            <div class="card-body">
              <student-nav @route-changed="toggleNavbar(false)"></student-nav>
            </div>
          </div>
        </vue-custom-scrollbar>
      </div>
    </div>
    <div class="lms-content">
      <div class="lms-content-body">
        <ul class="nav nav-line nav-line-profile mg-b-10">
          <li class="nav-item">
            <a
              aria-current="page"
              class="nav-link d-flex align-items-center router-link-exact-active router-link-active active"
            >
              Ёс зүйн тайлан
              <span class="badge">0</span>
            </a>
          </li>
        </ul>

        <div class="row">
          <div class="col-lg-8 col-xl-9">
            <vue-custom-scrollbar
              :style="`height: ${scrollHeight.content}px; position: relative; `"
            >
              <div class="row row-sm mg-b-25">
                <div class="col-md-6">
                  <div class="card card-event">
                    <img src="/assets/img/img27.jpg" class="card-img-top" alt />
                    <div class="card-body tx-13">
                      <h5>
                        <a>Үйл явдал</a>
                      </h5>
                      <p class="mg-b-0">
                        Mar 22 - Mar 24, World Trade Center Metro
                      </p>
                      <span class="tx-12 tx-color-03">Manila, Philippines</span>
                    </div>
                    <div class="card-footer tx-13">
                      <span class="tx-color-03">6,187 people interested</span>
                      <button class="btn btn-xs btn-secondary">
                        Interested
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </vue-custom-scrollbar>
          </div>
          <div class="col-sm-7 col-md-5 col-lg-4 col-xl-3 mg-t-40 mg-lg-t-0">
            <vue-custom-scrollbar
              :style="`height: ${scrollHeight.right}px; position: relative;`"
            >
              <div
                class="d-flex align-items-center justify-content-between mg-b-20"
              >
                <h6 class="tx-uppercase tx-semibold mg-b-0">
                  Гишүүнчлэлийн төлбөр
                </h6>
              </div>
              <ul class="list-unstyled media-list mg-b-15">
                <li class="media align-items-center">
                  <div
                    class="wd-40 ht-40 bg-dark tx-white d-flex align-items-center justify-content-center rounded"
                  >
                    <feather type="calendar" class="ht-25-f wd-25-f"></feather>
                  </div>
                  <div class="media-body pd-l-15">
                    <h6 class="mg-b-2">
                      <a href class="link-01">tulbur 1</a>
                    </h6>
                    <span class="tx-13 tx-color-03"
                      >Today, April 21, 5:00pm</span
                    >
                  </div>
                </li>
              </ul>

              <h6 class="tx-uppercase tx-semibold mg-t-50 mg-b-15">
                Гишүүн байгууллага
              </h6>

              <nav class="nav nav-classic tx-13">
                <a class="nav-link">
                  <span>Төрөл 1</span>
                  <span class="badge">20</span>
                </a>
              </nav>
            </vue-custom-scrollbar>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";
import vueCustomScrollbar from "vue-custom-scrollbar";

export default {
  components: {
    vueCustomScrollbar,
    studentNav: () => ({
      component: import("@/views/modules/lms/student/components/nav.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    })
  },
  data() {
    return {
      scrollHeight: {
        contentToolbarHeight: 49,
        nav: 0,
        content: 0,
        right: 0
      }
    };
  },
  mounted() {
    this.toggleBodyClass("addClass", "app-lms");
    require("@/assets/css/dynamic.lms.css");

    window.addEventListener("resize", this.getWindowHeight);
    this.getWindowHeight();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.getWindowHeight);
    this.toggleBodyClass("removeClass", "app-lms");
  },
  destroyed() {
    window.removeEventListener("resize", this.getWindowHeight);
    this.toggleBodyClass("removeClass", "app-lms");
  },
  methods: {
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    toggleNavbar(shown) {
      if (this.navbarMode == 0) {
        this.navbarMode = 1;
        this.toggleBodyClass("addClass", "lms-sidebar-show");
      } else if (this.navbarMode == 1) {
        if (shown) {
          this.toggleBodyClass("addClass", "navbar-nav-show");
        } else {
          this.navbarMode = 0;
          this.toggleBodyClass("removeClass", "lms-sidebar-show");
        }
      }
    },
    getWindowHeight() {
      let contentSub = 120;
      let navSub = 120;
      let rightSub = 120;
      if (screen.width <= 1024) {
        contentSub = 85;
        navSub = 85;
        rightSub = 85;
      }

      contentSub += this.scrollHeight.contentToolbarHeight;
      rightSub += this.scrollHeight.contentToolbarHeight;

      this.scrollHeight.content = window.innerHeight - contentSub;
      this.scrollHeight.nav = window.innerHeight - navSub;
      this.scrollHeight.right = window.innerHeight - rightSub;
    }
  }
};
</script>
